'use client';
import { TDdpCta } from "@/shared/types";
import Link from "next/link";
import { ButtonHTMLAttributes, LinkHTMLAttributes, ReactNode } from "react";
import { useCmsStore } from "../AppHooks";
import { useSearchParams } from "next/navigation";
export function DdpCta(props: {
    cta: Array<TDdpCta> | TDdpCta;
    children?: ReactNode;
} & LinkHTMLAttributes<HTMLAnchorElement> & ButtonHTMLAttributes<HTMLButtonElement> & {
    replace?: boolean;
}) {

    const { cta, className, children, ...otherProps } = props;

    const { show, text, url } = Array.isArray(cta) ? cta[0] : cta;
    const { locale } = useCmsStore()!;
    const searchParams = useSearchParams();
    const currentQuery = searchParams?.toString()
    if (!cta) return null;
    if (!show) return null;
    const _getFinalUrl = () => {
        if (otherProps.disabled) {
            return '#'
        }
        if (!url) return '#'
        let _url = url.split('?').map((item, index) => index === 0 ? item.toLowerCase() : item).join('?')
        _url = `/${locale}${url.startsWith('/') ? _url : `/${_url}`}`
        if (currentQuery) {
            if (url.includes('cocktailId')) {
                const q = new URLSearchParams(currentQuery)
                q.delete('cocktailId')
                _url = `${_url}${_url.includes('?') ? `&` : `?`}${q.toString()}`

            } else {
                _url = `${_url}${_url.includes('?') ? `&` : `?`}${currentQuery}`
            }
        }
        return _url
    }
    if (url) {
        if (url.startsWith('http') || url.startsWith('https')) {
            return <a className={`ddp-cta ${className} ${otherProps.disabled ? 'disabled' : ''}`} onClick={(event) => {
                if (otherProps.disabled) event.preventDefault();
                props.onClick?.(event)
            }} href={url} target="_blank" rel="noopener noreferrer" {...otherProps}>{text}{children}</a>
        }
        return <Link className={`ddp-cta ${className}  ${otherProps.disabled ? 'disabled' : ''}`} onClick={(event) => {
            if (otherProps.disabled) event.preventDefault();
            props.onClick?.(event)
        }} href={_getFinalUrl()}>{text}{children}</Link>
    }
    return <button className={`ddp-cta ${className}`} {...otherProps}>{text}{children}</button>
}